import $ from 'cash-dom';
import anime from 'animejs';

export const examplesComponent = async () => {
  console.log('examples');
  const scroll = $('#examples-desktop-scroll').get(0);
  const $back = $('#examples-desktop-back');
  const $forward = $('#examples-desktop-forward');

  console.log('examples-2', scroll);
  if (!scroll) return;

  let itemsPerScroll = parseInt(scroll.getAttribute('data-items-per-scroll'));
  if (isNaN(itemsPerScroll)) itemsPerScroll = 1;

  let count = parseInt(scroll.getAttribute('data-count'));
  count = Math.ceil(count / itemsPerScroll);

  let activeIndex = 0;
  console.log('count:', count);

  let initialId = parseInt(scroll.getAttribute('data-initial-id'));
  if (isNaN(initialId)) initialId = null;
  else {
    activeIndex = $('#examples-desktop-scroll').index(`#example-${initialId}`);
  }

  console.log(activeIndex);

  const update = () => {
    console.log('update', activeIndex);
    if (activeIndex > 0)
      $back
        .removeClass(
          'bg-transparent border-gray text-gray hover:border-gray-dark hover:text-gray-dark'
        )
        .addClass(
          'bg-white border-red text-red hover:border-red-dark hover:text-red-dark'
        );
    else
      $back
        .removeClass(
          'bg-white border-red text-red hover:border-red-dark hover:text-red-dark'
        )
        .addClass(
          'bg-transparent border-gray text-gray hover:border-gray-dark hover:text-gray-dark'
        );
    if (activeIndex < count - 1)
      $forward
        .removeClass(
          'bg-transparent border-gray text-gray hover:border-gray-dark hover:text-gray-dark'
        )
        .addClass(
          'bg-white border-red text-red hover:border-red-dark hover:text-red-dark'
        );
    else
      $forward
        .removeClass(
          'bg-white border-red text-red hover:border-red-dark hover:text-red-dark'
        )
        .addClass(
          'bg-transparent border-gray text-gray hover:border-gray-dark hover:text-gray-dark'
        );

    anime({
      targets: scroll,
      left: -activeIndex * scroll.offsetWidth,
      duration: 250,
      easing: 'easeOutQuad',
    });
  };

  $back.on('click', () => {
    if (activeIndex > 0) {
      --activeIndex;
      update();
    }
  });
  $forward.on('click', () => {
    if (activeIndex < count - 1) {
      ++activeIndex;
      update();
    }
  });

  update();
  setupExampleFilters();
};

// CATEGORY FILTERING
const setupExampleFilters = () => {
  const filterButtons = document.querySelectorAll('.example-filter-button');
  const cards = document.querySelectorAll(
    '#examples-desktop-scroll [data-category]'
  );

  // Get all unique valid categories from cards
  const validCategories = new Set();
  cards.forEach((card) => {
    const cat = card.getAttribute('data-category');
    if (cat) cat.split(' ').forEach((slug) => validCategories.add(slug));
  });

  filterButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const selectedCategory = btn.getAttribute('data-category');
      console.log('Selected category:', selectedCategory);

      // Update button styles (flip colors)
      filterButtons.forEach((b) => {
        b.classList.remove('bg-black', 'text-white');
        b.classList.add('bg-transparent', 'text-black');
      });
      btn.classList.remove('bg-transparent', 'text-black');
      btn.classList.add('bg-black', 'text-white');

      btn.setAttribute('active', '');
      btn.classList.add('bg-black', 'text-white');
      btn.classList.remove('bg-transparent', 'text-black');

      // Handle fallback
      const isValid =
        selectedCategory === 'vsetky' || validCategories.has(selectedCategory);
      if (!isValid) {
        console.warn(`Invalid category slug: ${selectedCategory}`);
      }

      cards.forEach((card) => {
        const cardCategory = card.getAttribute('data-category') || '';
        const show =
          selectedCategory === 'vsetky' ||
          cardCategory.split(' ').includes(selectedCategory);
        card.style.display = isValid && show ? '' : 'none';
      });
    });
  });
};
